import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiTransactionService } from '@services/api-transaction.service';

import { TransactionPackageModel } from '@models/TransactionModel';

import { SharedService } from '@services/shared.service';
import { ModalBase } from '@shared/modal-base.component';

@Component({
    selector: 'app-send-package',
    templateUrl: './send-package.component.html',
    styleUrls: ['./send-package.component.scss']
})
export class SendPackageComponent extends ModalBase<any> implements OnInit {

    @Input() sale: TransactionPackageModel;

    @ViewChild('sendGiviModal', { static: true }) modal: TemplateRef<any>;

    constructor(public location: Location,
        public router: Router,
        public modalService: NgbModal,
        public sharedService: SharedService,
        public apiTransactionService: ApiTransactionService) {
        super(modalService)
    }

    ngOnInit(): void {
    }

    onSendLink() {

        super.open(this.modal, {
        backdrop: 'static', keyboard: false,
        windowClass: 'modal-dialog-end modal-content-full'
        });
    }

    onClose() {

        super.close();
    }
}
